import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { t } from 'i18next';
import {
    Tabs,
    TabList,
    TabContent,
    Paragraph,
    Collapsible,
    Button,
} from '@sentara-health/optimahealth_web';
import { DesignatedRepresentativeProps } from './interface';
import { ProfileHeaderContent } from 'templates';

import {
    useDeviceType,
    DeviceTypes,
    NavigateConst,
} from 'common';
import { useForm } from 'react-hook-form';
import { Trans } from 'react-i18next';



const DesignatedRepresentative = ({
    expand = true,
    onExpand,
    onCollapse,
}: DesignatedRepresentativeProps) => {
    useForm({});

    const [loader] = useState(false); // work in progress
    const [showError] = useState<boolean>(false); // work in progress
    const [isActiveTab, setIsActiveTab] = useState<string>('tab1');
    const navigate = useNavigate();
    const deviceType = useDeviceType();
    const isMobile = deviceType === DeviceTypes.MOBILE;

    const handleClickAdd = () => {
        navigate(NavigateConst.csrProxyForm);
    };

    // mock data for designated representatives, will replace with API data in the future
    const designatedReps = [];
    const accountSharedReps = [];

    //mock tabs work in progress, will replace with API data in the future
    const tabs = {
        tab1: {
            id: 'tab1',
            tabName: t('csrGuardian.designatedRepTabName'),
            total: '2',
            content: <>
                <div className={`row ${designatedReps.length ? 'mt-3' : ''}`}>
                    <div className="col-xl-8 col-12 align-self-center">
                        <Paragraph
                            text={
                                <Trans i18nKey={t(`csrGuardian.${designatedReps.length ? 'designatedRepTabContent' : 'designatedRepTabContentDefault'}`)} />
                            }
                            variant="regular"
                            dataTestId={'designatedRepresentativeSection'}
                            className="mb-0 lineBrake"
                        />
                    </div>
                    <div className="col-xl-4 col-lg-6 col-12 mt-xl-auto mt-3 text-end">
                        <Button
                            dataTestId={`${t('csrGuardian.addDesignatedRepBtn')} Button`}
                            variant='primary_btn'
                            onClick={() => handleClickAdd()}
                        >{t('csrGuardian.addDesignatedRepBtn')}</Button>
                    </div>
                </div>
            </>,
        },
        tab2: {
            id: 'tab2',
            tabName: t('csrGuardian.accountsSharedTabName'),
            total: 0,
            content:
                <div className={`row ${accountSharedReps.length ? 'mt-3' : ''}`}>
                    <Paragraph
                        text={
                            <Trans
                                i18nKey={t(`csrGuardian.${accountSharedReps.length ? 'accountsSharedTabContent' : 'accountsSharedTabContentDefault'}`)}
                                values={{ brandName: t('common.brandName') }}
                                components={{ bold: <strong /> }}
                            />
                        }
                        variant="regular"
                        dataTestId={'designatedRepresentativeSection'}
                        className="mb-0 lineBrake"
                    />
                </div>,
        }
    };


    const renderTabs = () => {
        return (
            <>
                <Tabs
                    isMobile={isMobile}
                    tabs={Object.keys(tabs).map((key, index) => {
                        const tab = tabs[key as keyof typeof tabs];
                        return (
                            <TabList
                                isMobile={isMobile}
                                key={index}
                                tabId={key}
                                tabName={tab.tabName}
                                total={tab.total}
                                isActive={isActiveTab === key}
                                dataTestId={`${key}-tab`}
                                onClick={() => {
                                    setIsActiveTab(key);
                                }}
                            />
                        );
                    })}
                    tabsContent={Object.keys(tabs).map((key, index) => {
                        const tab = tabs[key as keyof typeof tabs];
                        return (
                            <TabContent
                                key={index}
                                tabId={key}
                                tabContent={tab?.content}
                                dataTestId={`${key}-tabContent`}
                                isActive={isActiveTab === key}
                            />
                        );
                    })}
                />
            </>
        );
    }

    return (
        <Collapsible
            title={t('profile.designatedRepresentativeTitle')}
            id={'designatedRepresentative'}
            isMobile={isMobile}
            key={`${'designatedRepresentative'}-${isMobile ? 'mobile' : 'desktop'}`}
            expand={expand}
            isLoading={loader}
            onExpand={onExpand}
            onCollapse={onCollapse}
            className="my-3 pb-2"
        >
            <div className="set_my_preferences">
                <div className="user_address_wrapper py-4 border_wrapper">
                    <ProfileHeaderContent
                        header={''}
                        contentOne={''}
                        contentOrObject={renderTabs()}
                        dataTestIdOne="designatedRepresentativeDescription"
                    />
                    {showError && (
                        <>
                            {/* future error message for designated representative */}
                        </>
                    )}
                </div>
            </div>
        </Collapsible>
    );
};

export default DesignatedRepresentative;
